Postlogin = (function (postlogin) {
    postlogin.LessonAssignmentStudentProgress = {};
    const me = postlogin.LessonAssignmentStudentProgress;

    const $studentProgressTable = $('#student-progress-table');
    const progressBars = [];

    const setupProgressBars = function () {
        const progressIndicatorContainers = document.querySelectorAll('.progress-indicator');
        if (progressIndicatorContainers.length) {
            progressIndicatorContainers.forEach((indicator) => {
                const progress = $(indicator).data('progress');
                const userId = $(indicator).data('user-id');
                const barLine = $(indicator).attr('id');

                const bar = new ProgressBar.Line(`#${barLine}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step: (state, progressBar) => {
                        progressBar.path.setAttribute('stroke', state.color);
                        progressBar.setText(`${Math.round(progressBar.value() * 100)} %`);
                    },
                });
                bar.animate(progress / 100); // Value from 0.0 to 1.0
                progressBars[userId] = bar;
            });
        }
    };

    const initBootstrapTable = () => {
        const assignmentId = $studentProgressTable.data('assignment-id');
        const lessonId = $studentProgressTable.data('lesson-id');
        const hasWrittenResponse = $studentProgressTable.data('has-written-response');

        const columns = [
            {
                title: '<i class="fa fa-check text-success" aria-hidden="true"></i>',
                field: 'completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    return +row.progress === 100 ? '<i class="fa fa-check text-success" aria-hidden="true"></i>' : '';
                },
            },
            {
                title: 'Name',
                field: 'student',
                align: 'left',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    const userViewUrl = $studentProgressTable.data('user-view-url').replace(':user_id', row.user_id);
                    const name = `${row.first_name} ${row.last_name}<br/>(${row.username})`.trim();

                    if (row.can_manage <= 0) {
                        return `${name}<br><em><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Student Unavailable</em>`;
                    }

                    return `<a href="${userViewUrl}">${name}</a>`;
                },
            },
            {
                title: 'Interest',
                field: 'interest',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                formatter(value) {
                    let interestEmoji = '';
                    if (value === 'positive') {
                        interestEmoji = 'fa-face-smile text-success';
                    } else if (value === 'neutral') {
                        interestEmoji = 'fa-face-meh';
                    } else if (value === 'negative') {
                        interestEmoji = 'fa-face-frown text-danger';
                    }

                    return `${value} <i class="fa-regular ${interestEmoji}" aria-hidden="true" />`;
                },
            },
            {
                title: 'Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    return row.progress === 100 ? '<i class="fa fa-check text-success" aria-hidden="true"></i>' : '';
                },
            },
            {
                title: 'Progress',
                field: 'progress',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value, row) => `
                    <div class="progress-indicator hidden-print" id="student-progress-${row.user_id}"
                        data-progress="${value}"
                        data-user-id="${row.user_id}">
                    </div>
                    <span class="visible-print">${value}%</span>
                `,
            },
        ];

        if (hasWrittenResponse) {
            columns.splice(2, 0, {
                title: 'Written<br>Responses',
                field: 'written_responses',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    if (row.can_manage <= 0 || value.length <= 0) {
                        return '';
                    }

                    return `
                        <a href="#"
                            data-toggle="modal"
                            data-target="#written-response-modal-${row.user_lesson_id}"
                        >
                            <i class="fa fa-comment" aria-hidden="true"></i>
                        </a>
                        <div class="modal demo-modals fade" id="written-response-modal-${row.user_lesson_id}"
                            tabindex="-1" role="dialog" aria-labelledby="personalized-modal">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <a type="button" class="close" data-dismiss="modal"
                                            aria-label="Close"><span aria-hidden="true">&times;</span></a>
                                        <div class="modal-title">
                                            Written Responses
                                        </div>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            ${value.map(
                        (response) => `
                                                    <div class="written-response">
                                                        ${response.instructions ? `<h2>${response.instructions}</h2>` : ''}
                                                        ${response.question_text ? `<h3>${response.question_text}</h3>` : ''}
                                                        <p>${response.response}</p>
                                                    </div>
                                            `,
                    )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                },
            });
        }

        $studentProgressTable.bootstrapTable({
            formatNoMatches: () => 'No activity to show',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: `/lessons/${lessonId}/assignments/${assignmentId}/json`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const searchParams = {};
                searchParams.search_term = params.searchText;
                searchParams.page = params.pageNumber;
                searchParams.page_size = params.pageSize;
                searchParams.order_by = params.sortName;
                searchParams.sort_order = params.sortOrder;
                return searchParams;
            },
            columns,
            responseHandler: (res) => ({ total: res.meta.total, rows: res.data }),
            onLoadSuccess: setupProgressBars,
            rowStyle(row) {
                let classes = '';
                if (row.can_manage <= 0) {
                    classes += 'disabled ';
                }

                if (row.progress < 33.3333) {
                    classes += 'danger ';
                } else if (row.progress < 66.6666) {
                    classes += 'warning ';
                } else if (row.progress < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    me.init = function () {
        initBootstrapTable();
    };

    return postlogin;
}(Postlogin || {}));
